import {useQuery} from '@apollo/client';
import {VulnerabilityOptions} from '../../schema-types/VulnerabilityOptions';
import {GET_VULNERABILITY_OPTIONS} from './vulnerabilityQueries';

export type VulnerabilityOptionLists = {
  vulnerabilityTypes: string[];
  serviceLevels: string[];
};

/**
 * The Curo picklists for the vulnerability type and Hubwise service level, and
 * whether the feature is available on this environment (the Curo entity only
 * exists on the Hubwise instance today).
 */
export const useVulnerabilityOptions = () => {
  const {data, loading, error} = useQuery<VulnerabilityOptions>(
    GET_VULNERABILITY_OPTIONS
  );
  if (error) {
    // The UI treats a failed lookup as "feature unavailable", so make the
    // cause visible rather than hiding the panel silently.
    console.error('vulnerabilityOptions query failed', error);
  }
  return {
    loading,
    isEnabled: data?.vulnerabilityOptions.isEnabled ?? false,
    vulnerabilityTypes: data?.vulnerabilityOptions.vulnerabilityTypes ?? [],
    serviceLevels: data?.vulnerabilityOptions.serviceLevels ?? [],
  };
};
